import { HttpClient } from '@angular/common/http';
import { Component, ComponentFactoryResolver, ElementRef, OnInit, Type, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
import { AlertController, ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { BannerComponent } from 'src/app/components/modals/banner/banner.component';

import { PendingReviewComponent } from 'src/app/components/modals/pending-review/pending-review.component';
import { SlidesArComponent } from 'src/app/countries/ar/pages/home/slides/slides.component';
import { SlidesPeComponent } from 'src/app/countries/pe/pages/home/slides/slides.component';
import { SlidesUyComponent } from 'src/app/countries/uy/pages/home/slides/slides.component';
import { HomeSlideDirective } from 'src/app/directives/home-slide.directive';
import { ReasonENUM } from 'src/app/interfaces/common.interfaces';
import { HomeSlide } from 'src/app/interfaces/home-slide.interface';
import { IChatMessage } from 'src/app/interfaces/messages.interface';
import { IReqConsultaNew } from 'src/app/interfaces/requests/requests.interfaces';
import { ApiConsultaService } from 'src/app/services/api-consulta.service';
import { AppLogService } from 'src/app/services/appLog.service';
import { CurrentCountryService } from 'src/app/services/current-country.service';
import { LoadingService } from 'src/app/services/misc/loading.service';
import { PushNotificationService } from 'src/app/services/native/push-notification.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { TabItem, TabsService } from 'src/app/services/tabs.service';
import { IUserData, UDEstateENUM } from 'src/app/services/user/user-data.interface';
import { UserDataService } from 'src/app/services/user/user-data.service';
import { ZohoService } from 'src/app/services/zoho.service';
import { OpenaiService } from '../../openai.service';
import { ApiNotificationsService } from '../../services/api-notifications.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  @ViewChild(HomeSlideDirective) homeSlideHost: HomeSlideDirective;
  @ViewChild('chatMessagesContainer') private chatMessagesContainer!: ElementRef;

  udeStates = UDEstateENUM;
  userData: IUserData;
  unreadNotifications: number;
  info: any;
  showchat: boolean;
  tabs: TabItem[] = [];
  modal: boolean;
  mobile: boolean;

  inicio: boolean;

  messages: IChatMessage[] = [];
  userMessage: string;
  linkDatosFacturacion: string;
  constructor(
    private openaiService: OpenaiService,
    private http: HttpClient,
    private router: Router,
    private userDataService: UserDataService,
    private apiConsultaService: ApiConsultaService,
    private currentCountryService: CurrentCountryService,
    private navigationService: NavigationService,
    private apiNotificationsService: ApiNotificationsService,
    private appLoggerService: AppLogService,
    private loadingService: LoadingService,
    private alertController: AlertController,
    private pushNotificationService: PushNotificationService,
    private resolver: ComponentFactoryResolver,
    private tabsService: TabsService,
    private modalController: ModalController,
    private zohoService: ZohoService,
    private appLogService: AppLogService
  ) {
    moment.locale('es');
    this.pushNotificationService.initService();
  }

  scrollToBottom(): void {
    try {
      const container = this.chatMessagesContainer.nativeElement;
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth', // Hace que el desplazamiento sea suave
      });
    } catch (err) {
      console.error('Error al desplazarse al final:', err);
    }
  }

  async chatgpt() {
    // Verifica si el mensaje no está vacío
    if (this.userMessage.trim() !== '') {
      // Agrega el mensaje del usuario al array de mensajes
      this.messages.push({
        content: this.userMessage,
        sender: 'user',
        timestamp: new Date(),
        status: 'read',
      });

      try {
        // Llamada al servicio de OpenAI para obtener la respuesta

        const response = await this.openaiService.sendMessage(this.userMessage).toPromise();
        this.userMessage = '';
        this.messages.push({
          content: response.choices[0].message.content,
          sender: 'bot',
          timestamp: new Date(),
          status: 'read',
        });
        setTimeout(() => {
          this.scrollToBottom();
        }, 1);
      } catch (error) {
        console.error('Error enviando el mensaje:', error);
      }

      // Limpia el campo de input después de enviar el mensaje
      this.userMessage = '';
    }
  }

  async ngOnInit() {
    if (this.isMobile()) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    const { value } = await Preferences.get({ key: 'link' });
    this.linkDatosFacturacion = value;
    if (this.linkDatosFacturacion) {
      this.mostrarAlertaFacturacion();
    }

    if (this.isMobile()) {
      const { value } = await Preferences.get({ key: 'code_empretienda' });
      if (value) {
        await Preferences.remove({ key: 'code_empretienda' });
        this.router.navigateByUrl(`/ar/integrations/empretienda/conectar?code=${value}`);
      }
    } else {
      const code = localStorage.getItem('code_empretienda');
      if (code) {
        localStorage.removeItem('code_empretienda');
        this.router.navigateByUrl(`/ar/integrations/empretienda/conectar?code=${JSON.parse(code)}`);
      }
    }

    localStorage.removeItem('aQueTeVasADedicar');

    this.inicio = false;
    this.logDeviceInfo();
    localStorage.removeItem('paymentId');

    if (this.isMobile()) {
      await Preferences.remove({ key: 'email' });
      await Preferences.remove({ key: 'clave' });
    } else {
      localStorage.removeItem('email');
      localStorage.removeItem('clave');
    }

    if (localStorage.getItem('paymentId')) {
      localStorage.removeItem('paymentId');
    }

    this.zohoService.algunaFuncionAsincronica();

    this.userDataService.getUserData().subscribe(
      (userData) => {
        this.userData = userData;
        // this.verificarUbicacionUsuario()
      },
      (error) => {
        console.error('Error al obtener los datos del usuario', error);
      }
    );

    if (this.isMobile()) {
    } else {
    }

    setTimeout(() => {
      this.inicio = true;
    }, 1500);
  }

  // async mostrarAlertaFacturacion() {
  //   const cuitEmisor = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'cuit_monotributista') || 'CUIT no especificado';
  //   const celularEmisor = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'celular_monotributista') || 'Sin número';
  //   const cuitReceptor = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'cuit_empresa') || 'CUIT no especificado';
  //   const celularReceptor = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'celular_empresa') || 'Sin número';
  //   const condicionIva = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'condicion_iva') || 'No especificada';
  //   const concepto = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'concepto') || 'Concepto no especificado';
  //   const cantidad = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'cantidad') || '1';
  //   const unidadMedida = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'unidad_medida') || '0';
  //   const precioUnitario = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'precio_unitario') || '0';

  //   const alert = await this.alertController.create({
  //     header: '¿Realizar factura rápida?',
  //     subHeader: `Factura a nombre de CUIT ${cuitReceptor}`,
  //     message: `
  //       <strong>Emisor:</strong><br>
  //       CUIT: ${cuitEmisor}<br>
  //       Celular: ${celularEmisor}<br><br>

  //       <strong>Receptor:</strong><br>
  //       CUIT: ${cuitReceptor}<br>
  //       Celular: ${celularReceptor}<br>
  //       Condición IVA: ${condicionIva}<br><br>

  //       <strong>Concepto:</strong> ${decodeURIComponent(concepto)}<br>
  //       Cantidad: ${cantidad}<br>
  //       Unidad de medida: ${unidadMedida}<br>
  //       Precio unitario: $${precioUnitario}<br><br>

  //       Si aceptás, serás redirigido a la pantalla de facturación.
  //     `,
  //     buttons: [
  //       {
  //         text: 'Cancelar',
  //         role: 'cancel',
  //         handler: async () => {
  //           console.log('El usuario canceló.');
  //           await Preferences.remove({ key: 'link' });
  //         },
  //       },
  //       {
  //         text: 'Aceptar',
  //         role: 'confirm',
  //         handler: async () => {
  //           if (this.linkDatosFacturacion) {
  //             this.router.navigateByUrl(this.linkDatosFacturacion);
  //             await Preferences.remove({ key: 'link' });
  //           }
  //         },
  //       },
  //     ],
  //     cssClass: 'custom-alert-style',
  //   });

  //   await alert.present();
  // }

  async mostrarAlertaFacturacion() {
    const cuitReceptor =
      this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'cuit_empresa') || 'CUIT no especificado';
    const concepto = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'concepto') || 'Concepto no especificado';
    const cantidad = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'cantidad') || '1';
    const precioUnitario = this.obtenerParametroDeUrl(this.linkDatosFacturacion, 'precio_unitario') || '0';

    const alert = await this.alertController.create({
      header: '¿Realizar factura rápida?',
      subHeader: `Factura a nombre de CUIT ${cuitReceptor}`,
      message: `${decodeURIComponent(concepto)}
       Total: $ ${parseFloat(precioUnitario) * parseFloat(cantidad)}`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cerrar',
          handler: async () => {
            console.log('El usuario canceló.');
            await Preferences.remove({ key: 'link' });
          },
        },
        {
          text: 'Aceptar',
          role: 'aceptar',
          handler: async () => {
            if (this.linkDatosFacturacion) {
              this.router.navigateByUrl(this.linkDatosFacturacion);
              await Preferences.remove({ key: 'link' });
            }
          },
        },
      ],
      cssClass: 'custom-alert-style',
    });

    await alert.present();
  }

  obtenerParametroDeUrl(url: string, parametro: string): string | null {
    try {
      const queryString = url.split('?')[1];
      const params = new URLSearchParams(queryString);
      return params.get(parametro);
    } catch (e) {
      console.error('Error al leer parámetro de URL:', e);
      return null;
    }
  }

  async logDeviceInfo() {
    const info = await Device.getInfo();
    this.info = info;
    localStorage.setItem('info', JSON.stringify(this.info));
    if (
      this.info.platform === 'web' &&
      (this.userData?.servicio_contable ||
        this.userData?.servicio_facturacion ||
        this.userData?.servicio_informe_fiscal)
    ) {
      const lastShown = localStorage.getItem('lastOpenedAppBannerTributoSimple');
      const oneWeek = 7 * 24 * 60 * 60 * 1000; // Milisegundos en una semana

      if (lastShown) {
        // Si ha pasado una semana desde la última vez que se mostró el modal, se vuelve a mostrar
        if (new Date().getTime() - new Date(lastShown).getTime() > oneWeek) {
          localStorage.setItem('lastOpenedAppBannerTributoSimple', new Date().toISOString());

          const modal = await this.modalController.create({
            component: BannerComponent,
            cssClass: 'modal-banner',
          });

          return await modal.present();
        } else {
          this.modal = false;
        }
      } else {
        // Primera vez que se abre la aplicación, no mostrar el modal
        this.modal = false;
        localStorage.setItem('lastOpenedAppBannerTributoSimple', new Date().toISOString());
      }
    }
  }

  verificarUbicacionUsuario() {
    // Verifica si el usuario está logueado
    if (this.userData && this.userData.pais) {
      // Verifica si el código del país es "ar" en la información del usuario
      if (this.userData.pais.code.toLowerCase() === 'ar') {
        // Si el código del país es "ar", el usuario está en Argentina
        console.log('El usuario está en Argentina');
        const pais = this.userData.pais.code;
        console.log(pais, '');
      } else {
        // Si el código del país no es "ar", realiza la redirección
        console.log('El usuario no está en Argentina');
        const eventValue = { page: 'home' };
        this.appLoggerService.logPageView(eventValue);
        this.router.navigate(['/prox/home']);
      }
    } else {
      // Si el usuario no está logueado, puedes manejar esta situación de acuerdo a tus necesidades
      console.log('El usuario no está logueado');
      // Por ejemplo, podrías redirigirlo a la página de inicio de sesión
      this.router.navigate(['/login']);
    }
  }

  ionViewWillEnter() {
    this.init();
  }

  async init() {
    await this.loadingService.present();

    // Unread Notifications
    this.apiNotificationsService.getNotifications(0, 0).subscribe((res) => {
      if (res) {
        this.unreadNotifications = res?.no_leidos;
        if (this.unreadNotifications > 999) this.unreadNotifications = 999;
      }
    });

    // UserData
    this.userData = await this.userDataService.refreshUserInfo();
    console.log('userData:', this.userData);

    this.loadingService.dismiss();

    if (this.userData) {
      this.verificarEstado();

      let component: Type<HomeSlide>;

      // TODO: Verificar que funcione en deploy.
      switch (this.currentCountryService.get().id) {
        case 'ar': {
          component = SlidesArComponent;
          break;
        }
        case 'pe': {
          component = SlidesPeComponent;
          break;
        }
        case 'uy': {
          component = SlidesUyComponent;
          break;
        }
      }

      if (component) {
        this.homeSlideHost.viewContainerRef.clear();
        const contentFactory = this.resolver.resolveComponentFactory(component);
        const contentRef = this.homeSlideHost.viewContainerRef.createComponent(contentFactory);
        contentRef.instance.userData = this.userData;
        contentRef.instance.dateNow = new Date();
      }

      this.tabs = await this.tabsService.buildTabs();
    }
  }

  async verificarEstado() {
    const { estado, id } = this.userData;

    switch (estado) {
      case UDEstateENUM.ESTADO_CONTRATADO:
        if (this.userData.tiene_clave_afip) {
          const body: IReqConsultaNew = {
            motivo: ReasonENUM.CAMBIO_PLAN,
          };

          this.apiConsultaService.putQuery(body).subscribe(
            async () => {
              await this.userDataService.refreshUserInfo(); // Actualizar datos del usuario
            },
            (err) => {
              console.error(err);
            }
          );
        } else {
          this.navigationService.navigateForward('/tax-keys/tax-form');
        }
        return;
      // case UDEstateENUM.ESTADO_REGISTRADO:
      //   this.navigationService.navigateRoot('/check-account');
      //   return;
      case UDEstateENUM.ESTADO_EMAIL_VALIDADO:
        this.navigationService.navigateRoot('/plans/choice-type');
        return;
      case UDEstateENUM.ESTADO_PLAN_SELECCIONADO:
        const navigationExtras: NavigationExtras = { state: { usuarioTSID: id } };
        if (this.userData.domicilio_fiscal) {
          this.navigationService.navigateRoot('/plans/detail', { state: { canBuy: true } });
        } else {
          this.navigationService.navigateRoot('/plans/choice-type/step0', navigationExtras);
        }
        return;
      case UDEstateENUM.ESTADO_REVISION:
      case UDEstateENUM.ESTADO_SERVICIO_CONTABLE:
      case UDEstateENUM.ESTADO_REVISION_CLAVE_FISCAL:
        const modal = await this.modalController.create({
          component: PendingReviewComponent,
          backdropDismiss: true,
          cssClass: 'modal-bienvenido',
        });
        modal.present();
        return;
    }
  }

  openNotifications() {
    this.navigationService.navigateForward('/notifications');
  }

  close() {
    this.modal = false;
  }
  goToApple() {
    window.location.href = 'https://apps.apple.com/ar/app/tributo-simple-monotributo/id1571573160';
  }
  goToAndroid() {
    window.location.href = 'https://play.google.com/store/apps/details?id=tributosimple.anfler.com.ar&hl=es_AR';
  }
  goToNone(event: Event) {
    event.stopPropagation(); // Evita que el evento 'click' se propague al contenedor modal
    this.modal = true;
  }

  openChat() {
    this.showchat = !this.showchat;
  }

  goToAsesor() {
    this.navigationService.navigateForward('/contact');
  }
  private isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
